module.exports = __webpack_public_path__ + "resources/img/solution_game_migration.ccdd47b0cb44bce8cb60d8a99bb12536.png";